import type { States, SetEvents } from './fsm.svelte'
import type { Matching } from './matching.svelte'

type ViewSnapshot = {
	state: States
	id: string | null
	children?: string[]
}

interface NavigationContext {
	fsm: { current: string; send: (event: SetEvents, payload?: Record<string, unknown>) => void }
	selectedId: string | null
	selectedChildrenIds: string[]
	isMatching: boolean
	matching: Matching | null
}

export class History {
	#stack: ViewSnapshot[] = $state([])

	get canGoBack(): boolean {
		return this.#stack.length > 0
	}

	push(snapshot: ViewSnapshot): void {
		this.#stack.push(snapshot)
	}

	pushState(appState: NavigationContext): void {
		this.push({
			state: appState.fsm.current as States,
			id: appState.selectedId,
			children:
				appState.selectedChildrenIds.length > 0 ? [...appState.selectedChildrenIds] : undefined
		})
	}

	#restoreSnapshot(appState: NavigationContext, prev: ViewSnapshot): void {
		if (prev.state === 'cluster' && prev.children) {
			appState.fsm.send('set_cluster' as SetEvents, { id: prev.id, children: prev.children })
		} else if (prev.state === 'matching') {
			// TODO JB/IS: maybe there is a better solution, because at the moment, we give the matchparam id which is like 'lot-1234' even though we had it separated at some point
			// TODO JB/IS: we load the matches again instead of keeping the state
			// TODO JB/IS: maybe we should give the type to the ViewSnapshot? But then we need to make sure, that it is not match, but only lot/pop or so
			if (!prev.id?.includes('-')) {
				console.error('prev id has invalid format, needs dash to be split', prev.id)
				return
			}
			const [type, id] = prev.id.split('-')
			appState.fsm.send('set_matching' as SetEvents, { id, type, flyTo: true })
		} else {
			appState.fsm.send(`set_${prev.state}` as SetEvents, { id: prev.id, flyTo: true })
		}
	}

	goBack(appstate: NavigationContext): void {
		if (appstate.isMatching) {
			appstate.matching?.handleMatchingHistory()
			return
		}
		// discard intermediate snapshots without navigating to them
		const prev = this.pop()
		if (!prev) return
		this.#restoreSnapshot(appstate, prev)
	}

	pop(): ViewSnapshot | undefined {
		return this.#stack.pop()
	}

	clear(): void {
		this.#stack = []
	}
}
